export default function isInternetwork(referral = {}) {
  return !!referral.is_internetwork;
}
